// Modules
import { createSelector } from 'reselect'

// Store
import selfSelector from './self'

export const favouritesCurrencyListSelector = createSelector(
  selfSelector,
  (self) => self.favouritesCurrencyList,
)
